import React from "react";
import styled, { css } from "styled-components";
import { Link as GatsbyLink } from "gatsby";
import { OutboundLink as GAOutboundLink } from "gatsby-plugin-google-gtag";

import { buttonStyles, secondaryButtonStyles } from "./Button";
import Arrow from "../images/icons/right-arrow.inline.svg";
import * as colors from "../styles/colors";

const types = {
  link: css`
    color: ${colors.muted};
    font-size: 24px;
    line-height: 120%;
    font-weight: 400;
    text-decoration: none;

    @media (max-width: 768px) {
      font-size: 21px;
    }

    ${({ inline }) =>
      !inline &&
      `
      display: flex;
      align-items: center;
      align-content: center; 
      margin-top: 14px;`}

    &:hover .more {
      left: 13px;
    }

    .more {
      position: relative;
      left: 6px;
      margin-top: -2px;
      transition: all 0.3s;
    }
    &:hover .more {
      transition: all 0.3s;
      left: 4px;
    }
  `,
  img: css``,
  button: buttonStyles,
  buttonSecondary: secondaryButtonStyles
};

const StyledLink = styled(GatsbyLink)`
  ${({ type }) => type in types && types[type]}
`;

export const OutboundLink = (props) => (
  <Link as={GAOutboundLink} {...props} />
);

export function Link({
  type = "link",
  more = false,
  inline = true,
  arrowColor = colors.dimmedLight,
  children,
  ...props
}) {
  return (
    <StyledLink type={type} {...props}>
      <span>{children}</span>
      {more ? (
        <Arrow
          className="more"
          fill={
            type === "buttonSecondary"
              ? colors.primaryGreen
              : arrowColor
          }
          alt="Arrow"
        />
      ) : null}
    </StyledLink>
  );
}
